import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { FR } from '../../components/ui/FieldRow.jsx';
import { NumInput } from '../../components/ui/Inputs.jsx';
import { Tabs } from '../../components/ui/Tabs.jsx';
import { DEVISE, fmt } from '../../lib/currency';
import { useReglages } from '../../api/reglages.jsx';
import { CLE_PACK_IA, packIaActif } from '../../lib/pack-ia';
import { C } from '../../theme/palette';
import { AssistantIa } from './AssistantIa.jsx';
import { RedactionIa } from './RedactionIa.jsx';

export function OutilsPage({ onNav, soc, estMixte, univers, setUnivers }) {
  const { reglageJson } = useReglages();
  // Le Pack IA se facture en sus. Les calculatrices, elles, ne sont pas de
  // l'IA : les retirer enleverait au client une fonction qu'il paie deja dans
  // son abonnement. Seul l'assistant s'efface.
  const avecIa = packIaActif(reglageJson(CLE_PACK_IA, null));
  const [tab, setTab] = useState('calc');
  const [ht, setHt] = useState(1000);
  const [tvaT, setTvaT] = useState(8.1);
  const [pa, setPa] = useState(50);
  const [pv, setPv] = useState(95);
  const [L, setL] = useState(4);
  const [W, setW] = useState(3);
  const [perte, setPerte] = useState(10);
  const ttc = ht * (1 + tvaT / 100);
  const margeChf = pv - pa,
    margePct = pa > 0 ? Math.round(((pv - pa) / pa) * 100) : 0;
  const surf = L * W,
    surfPerte = surf * (1 + perte / 100);
  const Field = ({ label, value, onChange }) => (
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 8, color: C.muted, marginBottom: 3 }}>{label}</div>
      <NumInput
        value={value}
        onChange={(e) => onChange(+e.target.value)}
        style={{
          width: '100%',
          border: '1px solid ' + C.border,
          borderRadius: 8,
          padding: '8px',
          fontSize: 11,
          textAlign: 'center',
        }}
      />
    </div>
  );
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle={avecIa ? '🤖 Outils & IA' : '🧮 Outils'}
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      {avecIa && (
        <Tabs
          items={[
            ['calc', '🧮 Calculatrices'],
            ['ia', '✨ Assistant'],
          ]}
          active={tab}
          onChange={setTab}
        />
      )}
      <div style={{ marginTop: 12 }} />
      {tab === 'calc' && (
        <div>
          <Card style={{ marginBottom: 11 }}>
            <Bar icon="🇨🇭" title="TVA HT ↔ TTC" color={C.teal} />
            <div style={{ padding: 13 }}>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <Field label="Montant HT" value={ht} onChange={setHt} />
                <Field label="Taux %" value={tvaT} onChange={setTvaT} />
              </div>
              <div style={{ background: C.tealL, borderRadius: 9, padding: 12 }}>
                <FR label="TVA" value={DEVISE + ' ' + fmt(ttc - ht)} />
                <FR label="Montant TTC" value={DEVISE + ' ' + fmt(ttc)} color={C.teal} bold last />
              </div>
            </div>
          </Card>
          <Card style={{ marginBottom: 11 }}>
            <Bar icon="📈" title="Marge commerciale" color={C.green} />
            <div style={{ padding: 13 }}>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <Field label="Prix d'achat" value={pa} onChange={setPa} />
                <Field label="Prix de vente" value={pv} onChange={setPv} />
              </div>
              <div style={{ background: C.greenL, borderRadius: 9, padding: 12 }}>
                <FR label="Marge" value={DEVISE + ' ' + fmt(margeChf)} />
                <FR label="Taux de marge" value={margePct + ' %'} color={C.green} bold last />
              </div>
            </div>
          </Card>
          <Card>
            <Bar icon="📐" title="Métré surface" color={C.navy} />
            <div style={{ padding: 13 }}>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <Field label="Longueur (m)" value={L} onChange={setL} />
                <Field label="Largeur (m)" value={W} onChange={setW} />
                <Field label="Perte %" value={perte} onChange={setPerte} />
              </div>
              <div style={{ background: C.navyXL, borderRadius: 9, padding: 12 }}>
                <FR label="Surface" value={fmt(surf) + ' m²'} />
                <FR
                  label="Avec pertes/chutes"
                  value={fmt(surfPerte) + ' m²'}
                  color={C.navy}
                  bold
                  last
                />
              </div>
            </div>
          </Card>
        </div>
      )}
      {/*
        L'assistant repond sur les donnees de la societe, la redaction compose
        un texte a coller : deux appels au meme Pack IA, dont le serveur tient
        le compte. L'historique de la conversation vit dans la page et s'efface
        avec elle.
      */}
      {avecIa && tab === 'ia' && (
        <div>
          {/* La carte de la maquette d'abord ; la conversation, propre à la production, ensuite. */}
          <RedactionIa />
          <div style={{ marginTop: 12 }}>
            <AssistantIa />
          </div>
        </div>
      )}
    </Shell>
  );
}
